export default "__VITE_ASSET__B16i$hr$__"